module.exports = __webpack_public_path__ + "static/media/Niveau_elN2_4_216300.5b2a680c.png";